"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, use } from "react";
import { usePoolsFiltersState } from "./usePoolsFilters";
export type PoolsFiltersContextValue = ReturnType<typeof usePoolsFiltersState>;
const PoolsFiltersContext = createContext<PoolsFiltersContextValue | null>(null);
export function PoolsFiltersProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const value = usePoolsFiltersState();
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <PoolsFiltersContext value={value}>{children}</PoolsFiltersContext>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function usePoolsFilters(): PoolsFiltersContextValue {
  const value = use(PoolsFiltersContext);
  if (!value) {
    throw new Error("usePoolsFilters must be used within PoolsFiltersProvider");
  }
  return value;
}